<template>
    <li>
        <div class="title"><span>所在地</span></div>
        <div class="detail">
            <input type="text" class="edit-pen" maxlength="250" v-model="address">
        </div>
    </li>
</template>

<script>
    export default {
        data() {
            return {
                address: '',
            }
        },
        created() {
            // 編集の場合
            if (this.$store.state.detail.set.brand.address) {
                this.address = this.$store.state.detail.set.brand.address;
                this.$store.state.register.form.address = this.$store.state.detail.set.brand.address;
            }
        },
        watch: {
            address: function (value) {
                this.$store.state.register.form.address = value;
            },
        }
    }
</script>